import { useEffect, useState, useRef } from 'react';
import { Hint, STOCK_ADJUST } from './constants';
import {
  Divider,
  Menu,
  MenuItem,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TableSortLabel,
} from '@mui/material';
import PageFooter from './pageFooter';
import {
  ChatLeft,
  PersonDash,
  PersonPlus,
  PersonCheck,
  Clipboard2Minus,
  Clipboard2Plus,
  Clipboard2Check,
  List,
  Trash,
  Grid3x3,
  PiggyBank,
  Send,
  SendSlash,
  Sliders,
  PatchCheck,
} from 'react-bootstrap-icons';
import { Api, SendEmail } from './interface';
import { getComparator, handleResize, idleTimeout, bake } from './common.js';
import Modal from 'react-bootstrap/Modal';
import { Button, ButtonGroup, Form, Stack } from 'react-bootstrap';

import { toast } from 'react-toastify';
import { shortDate, shortDtm } from './date';
import TransactionRequest from './transactionRequest';

import BadgeVerify from './badgeVerify';
import { IsRole } from './validator';
import TransactionModal from './transactionModal';
import NavTabs from './navTabs.js';
import TransactionDetails from './transactionDetails';
import PutAwayOrder from './putAwayOrder';
import GeekPickUpOrder from './geekPickUpOrder.js';
import { TRANSACTION_STATUS } from './constants';
import { GEEK_TRAS } from './constants';
import GeekStockTakeAdjust from './geekStockTakeAdjust.js';
import Spinner from 'react-bootstrap/Spinner';

function TransactionsList(props) {
  const [loader, setLoader] = useState(true);
  const [columns, setColumns] = useState([]);
  const [order, setOrder] = useState('desc');
  const [orderBy, setOrderBy] = useState('Transaction_DBID');
  const [rows, setRows] = useState([]);
  const [filteredRows, setfilteredRows] = useState([]);
  const [filterText, setFilterText] = useState('');
  const [history, setHistory] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(15);
  const [currentModal, setCurrentModal] = useState(null);
  const [pageTitle, setPageTitle] = useState(null);
  const [currentRowHover, setCurrentRowHover] = useState({});

  const [filterToggle, setFilterToggle] = useState(null);
  const [users, setUsers] = useState([]);
  const [allUsers, setAllUsers] = useState([]);

  const [locations, setLocations] = useState([]);

  const [summaryData, setSummaryData] = useState(null);

  const [currentRow, setCurrentRow] = useState(null);

  const [isKiosk, setIsKiosk] = useState(props.isKiosk);
  const [badge, setBadge] = useState('');

  const [headers, setHeaders] = useState(null);
  const [body, setBody] = useState(null);
  const badgeRef = useRef(badge);
  const setBadgeRef = (data) => {
    badgeRef.current = data;
    setBadge(badgeRef.current);
  };
  const kiosk = 'kiosk';
  const completeStatus = [
    TRANSACTION_STATUS.COMPLETE.DB_STATUS,
    TRANSACTION_STATUS.DECLINED.DB_STATUS,
  ];
  const columnsToHide = [
    'CurrentOID',
    'NewOID',
    'CreatedOID',
    'New Location',
    'Path',
    'TransactionIdentifier',
    'DueDate',
    'ChildEntity_DBID',
    'Geek Type',
    'isRequest',
    'isShip', // if the transaction is a ship transaction
    'Resolved', // from Geek+ stock adjust transactions
  ];
  if (props.matType === 'SSD') {
    columnsToHide.push('Component Lot ID');
  }

  const [actionContextAnchor, setActionContextAnchor] = useState(null);
  const [geekPickupCancelFlag, setGeekCancelPickupFlag] = useState(false);
  const handleIdle = () => {
    idleTimer.reset();

    if (isKiosk) {
      logout();
      window.location.reload(false);
    }
  };
  // timeout after 10 minutes of inactivity and page refresh
  const { idleTimer } = idleTimeout({ onIdle: handleIdle, idleTime: 600 });

  const logout = () => {
    let kioskUser = {
      name: 'kiosk',
      unique_name: 'kiosk',
      oid: 'kiosk',
    };
    bake({ key: 'user', value: kioskUser });
    bake({ key: 'kioskUserOID', value: 'kiosk' });
  };

  const openDetails = () => {
    setActionContextAnchor(null);
    setModal('Details');
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setPage(0);
    bake({
      props: props,
      key: 'rowsPerPage',
      value: parseInt(event.target.value, 10),
    });
    setRowsPerPage(parseInt(event.target.value, 10));
  };

  const openHistory = () => {
    setActionContextAnchor(null);
    getHistory(currentRow);
  };

  const resolveTr = () => {
    setActionContextAnchor(null);
    setModal('GeekStockAdjust');
  };

  const openDelete = () => {
    setActionContextAnchor(null);
    setModal('Delete');
  };

  const setTransactionHeaders = (row) => {
    let initHeaders =
      row.Type === 'SSD'
        ? [
            {
              label: 'Build ID',
              field: 'Build ID',
              show: true,
              edit: false,
              sortable: true,
            },
            {
              label: 'Quantity',
              field: 'RequestedQuantity',
              show: true,
              edit: false,
              requestModal: true,
            },
            {
              label: 'Status',
              field: 'Status',
              show: row.Status === TRANSACTION_STATUS.COMPLETE.DB_STATUS,
              edit: false,
            },
          ]
        : row.Type === 'Component'
          ? [
              {
                label: 'Lot ID',
                field: 'Component Lot ID',
                show: true,
                edit: false,
                requestModal: true,
                sortable: true,
              },
              {
                label: 'Quantity',
                field: 'RequestedQuantity',
                show: true,
                edit: false,
              },
              {
                label: 'Status',
                field: 'Status',
                show: row.Status === TRANSACTION_STATUS.COMPLETE.DB_STATUS,
                edit: false,
              },
            ]
          : null;
    if (row['Geek Type'] === 'PTO') {
      initHeaders.splice(1, 0, {
        label: 'Box ID',
        field: 'BoxNum',
        show: true,
        edit: false,
        sortable: true,
      });
    }
    setHeaders(initHeaders);
    return initHeaders;
  };

  const handleRowClick = (e, row) => {
    if (
      !(
        filterToggle === STOCK_ADJUST.PENDING ||
        filterToggle === STOCK_ADJUST.RESOLVED
      )
    ) {
      setTransactionHeaders(row);
      row = {
        ...row,
        EntityOwner: allUsers
          ?.find((user) => user['OID'] === row['CurrentOID'])
          ?.User_DBID.toString(),
      }; // EntityOwner should be a singular value, not an array
      setCurrentRow(row);

      if (isKiosk) {
        setModal('BadgeVerify');
      } else if ((isKiosk && badgeRef.current !== '') || !isKiosk) {
        if (
          [
            TRANSACTION_STATUS.REQUEST.DB_STATUS,
            TRANSACTION_STATUS.PKOCRE.DB_STATUS,
            TRANSACTION_STATUS.PKOCNL.DB_STATUS,
            TRANSACTION_STATUS.PKOCONBO.DB_STATUS,
          ].includes(row.Status) &&
          row.isRequest
        ) {
          setModal('RequestEdit');
        } else if (
          row['Geek Type'] === 'PTO' &&
          row.Status !== TRANSACTION_STATUS.COMPLETE.DB_STATUS
        ) {
          setModal('PTO');
        } else {
          getRowData(row);
        }
      }
    } else {
      setCurrentRow(row);
    }
  };
  // hover functions for rows to align with sticky Actions menu
  const setRowHover = (row) => {
    if (!currentModal) {
      setCurrentRowHover(row);
    }
  };

  const clearRowHover = () => {
    if (!currentModal) {
      setCurrentRowHover(null);
    }
  };

  const isHovered = (row) => {
    return currentRowHover?.Transaction_DBID === row.Transaction_DBID;
  };

  const setModal = (modal) => {
    clearRowHover();
    setCurrentModal(modal);
  };

  const getRowData = (row) => {
    let field = setTransactionHeaders(row)?.filter(
      (header) => header.sortable
    )?.[0]?.field;

    let newBody = {
      ...body,
      entityType: row.Type,
      transactionId: row['Transaction_DBID'],
      status: row.Status,
      newOwner: users.find((item) => item.UserName === row['New Owner']),
    };
    if (
      !(
        [
          TRANSACTION_STATUS.REQUEST.DB_STATUS,
          TRANSACTION_STATUS.COMPLETE.DB_STATUS,
          TRANSACTION_STATUS.PKOCRE.DB_STATUS,
          TRANSACTION_STATUS.PKOCNL.DB_STATUS,
        ].includes(row.Status) || row.isRequest
      )
    ) {
      Api({
        sp: 'getTransactionData',
        json: { transactionId: parseInt(row['Transaction_DBID'], 10) },
      }).then((response) => {
        response = response.sort((a, b) => {
          return a[field] > b[field] ? 1 : -1;
        });

        setSummaryData(response);
        let initAdditionalFields = [];

        initAdditionalFields =
          row.Type === 'SSD'
            ? [
                {
                  fieldType: 'list',
                  fieldMeta: 'Serial Number',
                  fieldName: 'Selected List',
                },
              ]
            : null;

        newBody = {
          ...newBody,
          additionalFields: initAdditionalFields,
          comment: row['Comments'],
          // for loan transactions, set new location
          newLocation: [
            TRANSACTION_STATUS.LOAN.DB_STATUS,
            TRANSACTION_STATUS.EXTENDLOAN.DB_STATUS,
          ].includes(row.Status)
            ? locations.find(
                (parent) => parent.Path === response[0]['New Location'].trim()
              )
            : null,
        };
        setBody(newBody);
        if (row.Status === TRANSACTION_STATUS.SHIP.DB_STATUS) {
          Api({
            sp: 'getTransactionExternalData',
            json: {
              transactionId: parseInt(row['Transaction_DBID'], 10),
            },
          }).then((response) => {
            newBody = {
              ...newBody,
              CompanyName: response[0]?.CompanyName,
              ContactName: response[0]?.ContactName,
              Email: response[0]?.Email,
              Address: response[0]?.Address,
              ShippingNumber: response[0]?.ShippingNumber,
              comment: response[0]?.comments,
            };
            setBody(newBody);
            setModal('Edit');
          });
        } else {
          setBody(newBody);
          setModal('Edit');
        }
      });
    }
    if (row.Status === TRANSACTION_STATUS.COMPLETE.DB_STATUS) {
      Api({
        sp: 'getTransactionCompletedData',
        json: {
          transactionId: parseInt(row['Transaction_DBID'], 10),
          geekPTO: row['Geek Type'],
        },
      }).then((response) => {
        response = response.sort((a, b) => {
          return a[field] > b[field] ? 1 : -1;
        });
        setSummaryData(response);
        newBody = {
          ...newBody,
          comment: response[0]?.comments,
        };
        setBody(newBody);
        setModal('Edit');
      });
    }
  };

  const verifyBadge = (b) => {
    if (allUsers.some((x) => x.Badge.includes(b))) {
      let user = allUsers.filter((x) => x.Badge.includes(b))[0];
      setBadgeRef(b);
      toast.success('Badge Verified Succesfully for ' + user.UserName);
      closeModal();
      getRowData(currentRow);
      bake({ key: 'kioskUserOID', value: user['OID'] });
    } else {
      toast.error('Badge Not Found');
    }
  };

  const addBadge = (body) => {
    Api({
      sp: 'addBadge',
      json: body,
    }).then((response) => {
      response.forEach((x) => {
        let val = x['Badge']?.split(',');
        x['Badge'] = val?.length > 0 ? val : [''];
      });
      let user = response.filter((x) => x.Badge.includes(body.badge))[0];
      let badgeType = !body.badgeType ? '' : 'Temporary ';
      toast.success(
        badgeType + 'Badge added successfully for ' + user?.UserName
      );

      //update user id to capture the badge owner in history
      bake({ key: 'kioskUserOID', value: user['OID'] });
      setAllUsers(response);
      closeModal(true);
      getRowData(currentRow);
    });
  };

  const closeModal = (refresh) => {
    setBody({});
    setSummaryData(null);
    setModal(null);
    if (refresh) {
      if (
        filterToggle === STOCK_ADJUST.PENDING ||
        filterToggle === STOCK_ADJUST.RESOLVED
      ) {
        getGeekAdjustmentData();
      } else {
        getData();
      }
    }
  };

  const clearData = () => {
    setColumns([]);
    setRows([]);
    setfilteredRows(() => []);
  };
  const getData = () => {
    clearData();
    setLoader(true);
    const transactionStatus =
      filterToggle === TRANSACTION_STATUS.COMPLETE.DB_STATUS
        ? TRANSACTION_STATUS.COMPLETE.DB_STATUS
        : TRANSACTION_STATUS.OPEN.DB_STATUS;

    Api({
      sp: 'getTransactions',
      json: { transactionType: props.matType, transactionStatus },
    }).then((response) => {
      response.forEach((r) => {
        r['Created Date'] = shortDate(r['Created Date']);
        r.Total = parseInt(r.Total?.toString()) ?? 0;

        let value = r['TransactionIdentifier'];
        r['TransactionIdentifier'] = value?.split(',');

        r['Transaction_DBID'] = r['Transaction_DBID']
          .toString()
          .padStart(8, '0');
        r['Path'] = r['Current Location'];
      });

      setRows(response);

      const alternateColumnHeaders = {
        'Current Location': 'Location',
        Transaction_DBID: 'Transaction ID',
        LoanDueDate: 'Loan Due Date',
      };

      const buildColumnDefinition = (field) => {
        return {
          id: field,
          label: alternateColumnHeaders[field] ?? field,
          display: !columnsToHide.includes(field),
        };
      };

      const getColumnDefinitions = (record) => {
        let keys = Object.keys(record);

        const transactionTypeSpecificFields = {
          SSD: 'Build ID',
          Component: 'Component Name',
        };

        let additionalColumns = [];
        additionalColumns.push({
          id: 'TransactionIdentifier',
          label: transactionTypeSpecificFields[record.Type],
          display: true,
        });

        additionalColumns.push({
          id: 'Actions',
          label: 'Actions',
          display: true,
        });

        return [
          ...keys.map((field) => buildColumnDefinition(field)),
          ...additionalColumns,
        ];
      };

      let cols = getColumnDefinitions(response[0]);

      cols = cols.map((col) => {
        return col.id === 'LoanDueDate' ? { ...col, display: false } : col;
      });
      setColumns(cols);
      filterRowsByText(response, true);
    });
  };

  const getGeekAdjustmentData = () => {
    clearData();
    setLoader(true);

    Api({
      sp: 'getGeekStockAdjustments',
      json: {},
    }).then((response) => {
      response.forEach((r) => {
        r['Creation Date'] = shortDate(r['Creation Date']);
        r['Adjustment ID'] = r['Adjustment ID'].toString().padStart(8, '0');
      });

      setRows(response);

      const buildColumnDefinition = (field) => {
        return {
          id: field,
          label: field,
          display: !columnsToHide.includes(field),
        };
      };

      const getColumnDefinitions = (record) => {
        let keys = Object.keys(record);

        let additionalColumns = [];
        if (filterToggle === STOCK_ADJUST.PENDING) {
          additionalColumns.push({
            id: 'Actions',
            label: 'Actions',
            display: true,
          });
        }

        return [
          ...keys.map((field) => buildColumnDefinition(field)),
          ...additionalColumns,
        ];
      };

      let cols = getColumnDefinitions(response[0]);
      setColumns(cols);
      filterRowsByText(response, true);
    });
  };

  useEffect(() => {
    let rpp = parseInt(bake({ props: props, key: 'rowsPerPage' }), 10);
    rpp = isNaN(rpp) ? 15 : rpp;
    setRowsPerPage(rpp);
    Api({
      sp: 'getNonMaterialPaths',
      json: {},
    }).then((parents) => {
      setLocations(parents);
    });
    Api({
      sp: 'getUsers',
      json: {},
    }).then((users) => {
      users.forEach((x) => {
        let val = x['Badge']?.split(',');
        x['Badge'] = val?.length > 0 ? val : [''];
      });

      // Remove Material Storage as new owner on Got It for regular users
      let nonClassStoreUsers = users.filter(
        (u) => u.UserName !== 'Material Storage'
      );
      setAllUsers(users);
      setUsers(IsRole('Material Storage') ? users : nonClassStoreUsers);
    });
  }, []);

  useEffect(() => {
    handleResize();
  });

  useEffect(() => {
    let pageTitle = props.myHomePage
      ? 'My Transactions'
      : props.matType + ' Transactions';
    setPageTitle(pageTitle);
  }, [props.matType]);

  useEffect(() => {
    if (props.isKiosk) {
      setIsKiosk(props.isKiosk);
      setFilterToggle(kiosk);
      getData();
    }
  }, [isKiosk]);

  useEffect(() => {
    if (
      filterToggle === STOCK_ADJUST.PENDING ||
      filterToggle === STOCK_ADJUST.RESOLVED
    ) {
      getGeekAdjustmentData();
    } else {
      getData();
    }
  }, [filterToggle, props.matType]);

  useEffect(() => {
    filterRowsByText();
  }, [filterText]);

  const filterRowsByText = (unfilteredRows, loaderflag) => {
    let f = unfilteredRows ?? rows;
    let filterToggled = isKiosk ? kiosk : filterToggle;
    if (!filterText?.length) {
      setfilteredRows(f);
    } else {
      f = f.filter((o) => {
        return Object.keys(o).some((k) => {
          if (!k.includes('OID')) {
            return o[k]
              ?.toString()
              .toLowerCase()
              .includes(filterText.toLowerCase());
          }
        });
      });
      setfilteredRows(f);
    }
    filterRows(filterToggled, f, loaderflag);
  };

  useEffect(() => {
    handleResize();
  });

  const toggleFilter = (filter) => {
    if (filterToggle === filter) {
      setFilterToggle(null);
      filter = null;
    } else {
      setFilterToggle(filter);
    }
  };

  const filterRows = (filter, r, loaderflag) => {
    let user = JSON.parse(localStorage.getItem('user'));
    let cols = [];
    let appliedFilter = filter ?? props.filter ?? null;
    switch (appliedFilter) {
      // Home Page filter to show transactions user is involved in
      case 'user':
        r = r.filter(
          (x) =>
            (x['CreatedOID'] === user.oid ||
              x['CreatedOID'] === user.oid ||
              x['NewOID'] === user.oid) &&
            !completeStatus.includes(x.Status)
        );
        break;
      // filter for transactions created by user
      case 'check':
        r = r.filter(
          (x) =>
            x['CreatedOID'] === user.oid && !completeStatus.includes(x.Status)
        );
        break;
      // filter for incoming transactions to the user
      case 'plus':
        r = r.filter(
          (x) => x['NewOID'] === user.oid && !completeStatus.includes(x.Status)
        );
        break;
      // filter for outgoing transactions from user
      case 'minus':
        r = r.filter(
          (x) =>
            x['CurrentOID'] === user.oid && !completeStatus.includes(x.Status)
        );
        break;
      // kiosk filter for Give Its from Material Storage owned drives
      case kiosk:
        r = r.filter(
          (x) =>
            x['Current Owner'] === 'Material Storage' &&
            x.Status === TRANSACTION_STATUS.GIVEIT.DB_STATUS &&
            (x['Geek Type'] === undefined || x['Geek Type'] !== 'PTO')
        );
        break;
      // loan transactions filter
      case TRANSACTION_STATUS.LOAN.DB_STATUS:
        r = r.filter((x) =>
          [
            TRANSACTION_STATUS.LOAN.DB_STATUS,
            TRANSACTION_STATUS.EXTENDLOAN.DB_STATUS,
            TRANSACTION_STATUS.RETURNLOAN.DB_STATUS,
          ].includes(x.Status)
        );
        cols = columns.map((col) => {
          return col.id === 'LoanDueDate' ? { ...col, display: true } : col;
        });
        setColumns(cols);
        break;
      //stock adjustment transactions filter
      case STOCK_ADJUST.PENDING:
        r = r.filter((x) => x.Resolved === 0);
        break;

      case STOCK_ADJUST.RESOLVED:
        r = r.filter((x) => x.Resolved === 1);
        break;
    }

    setfilteredRows(r);
    if (loaderflag) {
      setLoader(false);
    }
  };

  const geekCancelDisabled = () => {
    // need to align with the new transaction status that will be applied
    // cancel only the transactions that have been created in G+ for pickup
    return (
      !currentRow ||
      !(currentRow.Status === TRANSACTION_STATUS.PKOCRE.DB_STATUS)
    );
  };

  const geekPickupDisabled = () => {
    // enable Pickup only for Request Transaction
    return (
      !currentRow ||
      ![
        TRANSACTION_STATUS.REQUEST.DB_STATUS,
        TRANSACTION_STATUS.PKOCNL.DB_STATUS,
        TRANSACTION_STATUS.GEEKPICKUP.DB_STATUS,
        TRANSACTION_STATUS.PKOERR.DB_STATUS,
      ].includes(currentRow.Status)
    );
  };

  const cancelGeek = () => {
    setActionContextAnchor(null);
    setGeekCancelPickupFlag(true);
    setModal('GeekPickUp');
  };

  const headerSort = (event) => {
    let label = event.target.innerText;
    let column = columns.find((column) => column.label === label);

    if (column.id === 'History') {
      return;
    }

    let dir =
      orderBy === column.id ? (order === 'asc' ? 'desc' : 'asc') : 'asc';
    setOrder(dir);
    setOrderBy(column.id);
    filteredRows.sort(getComparator(dir, column.id));
  };
  const geekPickUp = () => {
    setActionContextAnchor(null);
    setModal('GeekPickUp');
  };
  const getHistory = (row) => {
    Api({
      sp: 'getTransactionHistory',
      json: { id: parseInt(row['Transaction_DBID']) },
    }).then((response) => {
      response.forEach((r) => {
        r['Timestamp'] = shortDtm(r['Timestamp']);
      });
      setHistory(response);
      setCurrentRow(row);
      setModal('History');
    });
  };

  const handleContextClick = (event, row) => {
    setCurrentRow(row);
    setTransactionHeaders(row);
    event.stopPropagation();
    setActionContextAnchor(event.target);
  };

  const deleteRow = () => {
    SendEmail(
      'instantEmailGiveGotRequest',
      {
        emailSubject: 'Request ' + currentRow['Transaction_DBID'] + ' Canceled',
        transactionId: parseInt(currentRow['Transaction_DBID'], 10),
        status: 'Canceled',
      },
      { callBack: deleteCallback }
    );
  };

  // function to handle both page change and rows per page change from PageFooter component for Transactions page
  const updateSearchParams = (params) => {
    if (params.rows !== undefined) {
      handleChangeRowsPerPage({ target: { value: params.rows } });
    }
    if (params.page !== undefined) {
      handleChangePage(null, params.page);
    }
  };

  const deleteCallback = () => {
    closeModal();
    Api({
      sp: 'deleteTransaction',
      json: { id: parseInt(currentRow['Transaction_DBID'], 10) },
    }).then((res) => {
      if (res[0]?.error) {
        toast.error(res[0].error);
        return res[0].error;
      } else {
        toast.success(
          'Request ' + currentRow['Transaction_DBID'] + ' canceled'
        );
        getData();
      }
    });
  };

  const updateBody = (newBody) => {
    setBody(newBody);
  };

  // Add getPage function for PageFooter compatibility
  const getPage = ({ page: newPage, paging, rows }) => {
    if (paging && newPage !== undefined) {
      handleChangePage(null, newPage);
    }
    if (rows !== undefined) {
      setRowsPerPage(parseInt(rows, 10));
      handleChangeRowsPerPage({ target: { value: rows } });
    }
  };

  return (
    <div className="main-container">
      <div className="mt-2 d-flex justify-content-between align-items-center">
        {props.myHomePage ? (
          <div
            className={
              window.location.href.indexOf('elm.') !== -1
                ? 'gradient-myHomePage w-100'
                : window.location.href.indexOf('elm-qa') !== -1
                  ? 'gradient-myHomePage-qa w-100'
                  : 'gradient-myHomePage-dev w-100'
            }
          >
            <h2 className={props.myHomePage ? 'myHomePage-header' : ''}>
              {pageTitle}
            </h2>
          </div>
        ) : (
          <h2>{pageTitle}</h2>
        )}
        {!props.myHomePage ? (
          <>
            {/* Use only the transactions pages for Kiosk */}
            {isKiosk ? (
              <NavTabs
                navItems={[
                  { name: 'SSD', route: '/kiosk/transactions/ssd' },
                  {
                    name: 'COMPONENT',
                    route: '/kiosk/transactions/component',
                  },
                ]}
              />
            ) : (
              <NavTabs
                navItems={[
                  {
                    name: 'INVENTORY',
                    route: '/' + props.matType.toLowerCase(),
                  },
                  {
                    name: 'TRANSACTIONS',
                    route: '/transactions/' + props.matType.toLowerCase(),
                  },
                ]}
              />
            )}
          </>
        ) : null}
      </div>
      {/* hide the button group for home page */}
      <Stack direction="horizontal" gap={3}>
        <Form.Control
          placeholder="Search"
          value={filterText}
          onChange={(e) => {
            setFilterText(e.target.value);
          }}
        />

        {!isKiosk && !props.myHomePage ? (
          <ButtonGroup>
            <Hint
              placement="top"
              delay={{ show: 250, hide: 400 }}
              title="Toggle Give Its Created By Me"
            >
              <Button
                size="sm"
                onClick={() => toggleFilter('check')}
                variant={
                  filterToggle === 'check' ? 'primary' : 'outline-primary'
                }
              >
                <PersonCheck size={28} />
              </Button>
            </Hint>
            <Hint
              placement="top"
              delay={{ show: 250, hide: 400 }}
              title="Toggle Give Its From Me"
            >
              <Button
                size="sm"
                onClick={() => toggleFilter('minus')}
                variant={
                  filterToggle === 'minus' ? 'primary' : 'outline-primary'
                }
              >
                <PersonDash size={28} />
              </Button>
            </Hint>
            <Hint
              placement="top"
              delay={{ show: 250, hide: 400 }}
              title="Toggle Give Its To Me"
            >
              <Button
                size="sm"
                onClick={() => toggleFilter('plus')}
                variant={
                  filterToggle === 'plus' ? 'primary' : 'outline-primary'
                }
              >
                <PersonPlus size={28} />
              </Button>
            </Hint>
            <Hint
              placement="top"
              delay={{ show: 250, hide: 400 }}
              title="Toggle Requests"
            >
              <Button
                size="sm"
                onClick={() => toggleFilter('Request')}
                variant={
                  filterToggle === 'Request' ? 'primary' : 'outline-primary'
                }
              >
                <Clipboard2Minus size={28} />
              </Button>
            </Hint>
            <Hint
              placement="top"
              delay={{ show: 250, hide: 400 }}
              title="Toggle Give Its"
            >
              <Button
                size="sm"
                onClick={() => toggleFilter('Give It')}
                variant={
                  filterToggle === 'Give It' ? 'primary' : 'outline-primary'
                }
              >
                <Clipboard2Plus size={28} />
              </Button>
            </Hint>
            <Hint
              placement="top"
              delay={{ show: 250, hide: 400 }}
              title="Toggle Loans"
            >
              <Button
                size="sm"
                onClick={() => toggleFilter(TRANSACTION_STATUS.LOAN.DB_STATUS)}
                variant={
                  filterToggle === TRANSACTION_STATUS.LOAN.DB_STATUS
                    ? 'primary'
                    : 'outline-primary'
                }
              >
                <PiggyBank size={28} />
              </Button>
            </Hint>
            <Hint
              placement="top"
              delay={{ show: 250, hide: 400 }}
              title="Toggle Completed"
            >
              <Button
                size="sm"
                onClick={() =>
                  toggleFilter(TRANSACTION_STATUS.COMPLETE.DB_STATUS)
                }
                variant={
                  filterToggle === TRANSACTION_STATUS.COMPLETE.DB_STATUS
                    ? 'primary'
                    : 'outline-primary'
                }
              >
                <Clipboard2Check size={28} />
              </Button>
            </Hint>
            {props.matType === 'SSD' ? (
              <>
                {' '}
                <Hint
                  placement="top"
                  delay={{ show: 250, hide: 400 }}
                  title="Pending Stocktake Adjustment (Geek+)"
                >
                  <Button
                    size="sm"
                    onClick={() => toggleFilter(STOCK_ADJUST.PENDING)}
                    variant={
                      filterToggle === STOCK_ADJUST.PENDING
                        ? 'primary'
                        : 'outline-primary'
                    }
                  >
                    <Sliders size={26} />
                  </Button>
                </Hint>{' '}
                <Hint
                  placement="top"
                  delay={{ show: 250, hide: 400 }}
                  title="Processed Stocktake Adjustment (Geek+)"
                >
                  <Button
                    size="sm"
                    onClick={() => toggleFilter(STOCK_ADJUST.RESOLVED)}
                    variant={
                      filterToggle === STOCK_ADJUST.RESOLVED
                        ? 'primary'
                        : 'outline-primary'
                    }
                  >
                    <PatchCheck size={28} />
                  </Button>
                </Hint>{' '}
              </>
            ) : null}
          </ButtonGroup>
        ) : null}
      </Stack>
      <Paper sx={{ width: '100%' }}>
        <TableContainer
          component={Paper}
          className={
            !filteredRows?.length
              ? 'tableContainer no-scroll'
              : 'tableContainer'
          }
          id={filteredRows?.length > 0 ? 'tab-container' : 'tableContainer'}
        >
          <Table
            stickyHeader
            aria-label="sticky table"
            size="small"
            padding="none"
          >
            {/* Column Headers */}
            <TableHead>
              <TableRow>
                {columns
                  .filter((column) => column.display)
                  .map((column) => (
                    <TableCell
                      key={column.id}
                      align={column.numeric ? 'right' : 'left'}
                      padding={column.disablePadding ? 'none' : 'normal'}
                      sortDirection={orderBy === column.id ? order : false}
                      // sticky Actions Header
                      className={
                        column.id === 'Actions'
                          ? 'sticky-last-col search-table-header search-table-header-effect'
                          : ''
                      }
                    >
                      {' '}
                      {column.id !== 'Actions' ? (
                        <TableSortLabel
                          active={orderBy === column.id}
                          direction={orderBy === column.id ? order : 'asc'}
                          className={'header-sort-icon'}
                        >
                          <span
                            className={'col-header table-header pr-2'}
                            onClick={headerSort}
                          >
                            {column.label}
                          </span>
                        </TableSortLabel>
                      ) : (
                        <span
                          className={'col-header table-header pr-2'}
                          onClick={headerSort}
                        >
                          {column.id}
                        </span>
                      )}
                    </TableCell>
                  ))}
              </TableRow>
            </TableHead>

            {loader ? (
              <div className="d-flex justify-content-center align-items-center loader-container">
                <Spinner animation="border" variant="dark" />
              </div>
            ) : filteredRows.length === 0 ? (
              <TableRow>
                <TableCell colSpan={columns.length}>
                  No data found for the filter
                </TableCell>
              </TableRow>
            ) : (
              <>
                <TableBody>
                  {filteredRows
                    .slice()
                    .sort(getComparator(order, orderBy))
                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                    .map((row, id) => {
                      return (
                        <TableRow
                          className={
                            filterToggle === STOCK_ADJUST.PENDING ||
                            filterToggle === STOCK_ADJUST.RESOLVED
                              ? 'giveitListTable'
                              : 'giveitListTable pointer'
                          }
                          hover
                          onMouseEnter={() => setRowHover(row)}
                          onMouseLeave={() => clearRowHover()}
                          role="checkbox"
                          tabIndex={-1}
                          key={id}
                          onClick={(e) => handleRowClick(e, row)}
                        >
                          {columns
                            .filter((column) => column.display)
                            .map((column) => {
                              const value = row[column.id];
                              // css for Actions menu burger menu based on row hover
                              let tableCellClass =
                                column.id === 'Actions'
                                  ? 'sticky-last-col'
                                  : '';
                              tableCellClass += ' search-table-col';
                              tableCellClass += isHovered(row)
                                ? ' search-row-hover'
                                : '';

                              return column.id === 'History' ? (
                                <TableCell
                                  key={column.id}
                                  align="center"
                                  onClick={(e) => openHistory(e, row)}
                                >
                                  <ChatLeft color="blue" size={18} />
                                </TableCell>
                              ) : column.id === 'Actions' ? (
                                <TableCell
                                  key={column.id}
                                  align="center"
                                  className={tableCellClass}
                                  // onClick={(e) => openHistory(e, row)}
                                  onClick={(e) => handleContextClick(e, row)}
                                >
                                  <List
                                    size={24}
                                    className="pointer row-menu-icon"
                                    align="center"
                                  />
                                </TableCell>
                              ) : ['New Location', 'Current Location'].includes(
                                  column.id
                                ) ? (
                                <TableCell key={column.id} align={column.align}>
                                  {' '}
                                  {value
                                    ?.split(' > ')
                                    .slice(0)
                                    .map((v, i) => {
                                      return (
                                        <span
                                          key={i}
                                          className="search-meta-value"
                                        >
                                          {'' + v}
                                        </span>
                                      );
                                    })}
                                </TableCell>
                              ) : ['TransactionIdentifier'].includes(
                                  column.id
                                ) ? (
                                <TableCell
                                  key={column.id}
                                  align={column.align}
                                  className="giveit-buildid-wrap"
                                >
                                  {' '}
                                  <div className="transactions-build-id mb-2">
                                    <br />
                                    {Array.isArray(value) ? (
                                      value.length > 1 ? (
                                        <>
                                          {' '}
                                          {value.map((v, i) => {
                                            if (i < 3) {
                                              return (
                                                <span
                                                  key={i}
                                                  className="search-meta-value"
                                                >
                                                  {'' + v}
                                                </span>
                                              );
                                            }
                                          })}
                                          {value.length > 3 ? (
                                            <span className="search-meta-value">
                                              {'...' +
                                                (value.length - 3) +
                                                ' more'}
                                            </span>
                                          ) : null}{' '}
                                        </>
                                      ) : (
                                        value
                                      )
                                    ) : (
                                      value
                                    )}
                                  </div>
                                </TableCell>
                              ) : column.id === 'Status' ? (
                                <TableCell key={column.id} align={column.align}>
                                  <span className="transaction-status-cell">
                                    {
                                      TRANSACTION_STATUS[
                                        Object.keys(TRANSACTION_STATUS).filter(
                                          (status) =>
                                            TRANSACTION_STATUS[status]
                                              .DB_STATUS === value
                                        )[0]
                                      ]?.DESCRIPTION
                                    }{' '}
                                    {value === 'Complete' && row['Geek Type']
                                      ? '(' + GEEK_TRAS[row['Geek Type']] + ')'
                                      : ''}
                                  </span>
                                </TableCell>
                              ) : (
                                <TableCell key={column.id} align={column.align}>
                                  {column.format && typeof value === 'number'
                                    ? column.format(value)
                                    : value}
                                </TableCell>
                              );
                            })}
                        </TableRow>
                      );
                    })}
                </TableBody>
              </>
            )}
          </Table>
        </TableContainer>

        <PageFooter
          totalRows={filteredRows.length}
          myHomePage={props.myHomePage}
          level={props.level}
          page={page}
          setPage={setPage}
          getPage={getPage}
          updateSearchParams={updateSearchParams}
          selectedRows={[]} // Add selected rows if you have row selection functionality
        />
      </Paper>{' '}
      {currentModal === 'History' ? (
        <Modal
          show={currentModal === 'History'}
          onHide={closeModal}
          className="entity-modal"
          size="xl"
        >
          <Modal.Header closeButton="true">
            <Modal.Title>
              {GEEK_TRAS[currentRow['Geek Type']]}
              Transaction {currentRow['Transaction_DBID']} History
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="history-modal-box">
              <Paper sx={{ width: '100%' }}>
                <TableContainer
                  component={Paper}
                  className="tableContainer"
                  id="tab-container"
                >
                  <Table stickyHeader aria-label="sticky table">
                    {/* Column Headers */}
                    <TableHead>
                      <TableRow>
                        {Object.keys(history[0])
                          .map((x) => ({ id: x }))
                          .map((column) => (
                            <TableCell
                              key={column.id}
                              align={column.numeric ? 'right' : 'left'}
                              padding={
                                column.disablePadding ? 'none' : 'normal'
                              }
                            >
                              <span className={'col-header table-header pr-2'}>
                                {column.id}
                              </span>
                            </TableCell>
                          ))}
                      </TableRow>
                    </TableHead>

                    {/* Table Content */}
                    <TableBody>
                      {history.map((row, id) => {
                        return (
                          <TableRow
                            className="pointer"
                            hover
                            role="checkbox"
                            tabIndex={-1}
                            key={id}
                          >
                            {Object.keys(history[0])
                              .map((x) => ({
                                id: x,
                              }))
                              .map((column) => {
                                const value = row[column.id];
                                return column.id === 'Location' ? (
                                  <TableCell
                                    key={column.id}
                                    align={column.align}
                                  >
                                    {value?.split(' > ').map((v, i) => {
                                      return (
                                        <span
                                          key={i}
                                          className="search-meta-value"
                                        >
                                          {'' + v}
                                        </span>
                                      );
                                    })}
                                  </TableCell>
                                ) : (
                                  <TableCell
                                    key={column.id}
                                    align={column.align}
                                  >
                                    {column.format && typeof value === 'number'
                                      ? column.format(value)
                                      : value}
                                  </TableCell>
                                );
                              })}
                          </TableRow>
                        );
                      })}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Paper>
            </div>
          </Modal.Body>
        </Modal>
      ) : null}
      {currentModal === 'Edit' ? (
        <TransactionModal
          headers={headers}
          show={currentModal === 'Edit'}
          title={
            currentRow.Status === TRANSACTION_STATUS.COMPLETE.DB_STATUS
              ? 'Request ' + currentRow['Transaction_DBID']
              : currentRow.Status === TRANSACTION_STATUS.GIVEIT.DB_STATUS
                ? 'Got It ' + currentRow['Transaction_DBID']
                : 'Got It (' +
                  currentRow.Status +
                  ') ' +
                  currentRow['Transaction_DBID']
          }
          close={(refresh) => closeModal(refresh)}
          type={currentRow.Status}
          summaryData={summaryData}
          txnType={'GotIt'}
          matType={props.matType}
          currentRow={currentRow}
          body={body}
          updateBody={(x) => updateBody(x)}
        ></TransactionModal>
      ) : null}
      {currentModal === 'Details' ? (
        <TransactionDetails
          show={currentModal === 'Details'}
          closeModal={closeModal}
          row={currentRow}
        />
      ) : null}
      {currentModal === 'RequestEdit' ? (
        <TransactionRequest
          editing={currentModal === 'RequestEdit'}
          closeModal={closeModal}
          locations={locations}
          headers={headers}
          users={allUsers}
          currentRow={currentRow}
          matType={props.matType}
        />
      ) : null}
      {currentModal === 'BadgeVerify' ? (
        <BadgeVerify
          verifying={currentModal === 'BadgeVerify'}
          users={allUsers}
          verifyBadge={(b) => verifyBadge(b)}
          closeModal={() => closeModal()}
          addBadge={(body) => addBadge(body)}
        />
      ) : null}
      {currentModal === 'GeekPickUp' ? (
        <GeekPickUpOrder
          show={currentModal === 'GeekPickUp'}
          closeModal={(refresh) => closeModal(refresh)}
          transaction={currentRow}
          headers={headers}
          geekPickupCancelFlag={geekPickupCancelFlag}
        />
      ) : null}
      {currentModal === 'GeekStockAdjust' ? (
        <GeekStockTakeAdjust
          show={currentModal === 'GeekStockAdjust'}
          closeModal={(refresh) => closeModal(refresh)}
          transaction={currentRow}
        />
      ) : null}
      {currentModal === 'PTO' ? (
        <PutAwayOrder
          title="Give"
          show={currentModal === 'PTO'}
          close={() => closeModal(true)}
          currentRow={currentRow}
        ></PutAwayOrder>
      ) : null}
      {currentModal === 'Delete' ? (
        <Modal
          show={currentModal === 'Delete'}
          onHide={closeModal}
          className="entity-modal"
        >
          <Modal.Header>
            <Modal.Title>Confirm Cancel</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {currentRow.Status} {currentRow['Transaction_DBID']} will be
            canceled. All associated data will be reverted.
          </Modal.Body>
          <Modal.Footer>
            <div className="confirm">
              <Button
                variant="outline-primary"
                onClick={() => closeModal(true)}
                className="footer-button"
              >
                Cancel
              </Button>
              <Button
                className="ms-2 footer-button"
                variant="danger"
                onClick={() => {
                  deleteRow();
                }}
              >
                Confirm
              </Button>
            </div>
          </Modal.Footer>
        </Modal>
      ) : null}
      <Menu
        id="basic-menu"
        anchorEl={actionContextAnchor}
        open={actionContextAnchor !== null}
        onClose={() => setActionContextAnchor(null)}
        MenuListProps={{
          'aria-labelledby': 'basic-button',
        }}
      >
        {filterToggle === STOCK_ADJUST.PENDING ? (
          <MenuItem onClick={() => resolveTr()}>
            <Grid3x3 className="context-icon" onClick={resolveTr} />
            Resolve
          </MenuItem>
        ) : null}

        {filterToggle !== STOCK_ADJUST.PENDING &&
        filterToggle !== STOCK_ADJUST.RESOLVED ? (
          <MenuItem onClick={() => openHistory()}>
            <ChatLeft className="context-icon" onClick={openHistory} />
            History
          </MenuItem>
        ) : null}
        {filterToggle !== STOCK_ADJUST.PENDING &&
        filterToggle !== STOCK_ADJUST.RESOLVED ? (
          <MenuItem onClick={() => openDetails()}>
            <Grid3x3 className="context-icon" onClick={openDetails} />
            Details
          </MenuItem>
        ) : null}

        {IsRole('Material Storage') && !geekPickupDisabled() ? (
          <MenuItem onClick={() => geekPickUp()} show={geekPickupDisabled()}>
            <Send className="context-icon" onClick={geekPickUp} />
            Pickup from Geek
          </MenuItem>
        ) : null}

        {IsRole('Material Storage') && !geekCancelDisabled() ? (
          <MenuItem onClick={() => cancelGeek()} show={geekCancelDisabled()}>
            <SendSlash className="context-icon" onClick={cancelGeek} />
            Cancel Geek Pickup
          </MenuItem>
        ) : null}
        {/* avoid white screen crash until user is logged in */}
        {JSON.parse(localStorage.getItem('user'))?.oid ===
        currentRow?.CreatedOID ? (
          <span>
            <Divider />
            <MenuItem onClick={() => openDelete()}>
              <Trash color="red" className="context-icon" />
              Cancel
            </MenuItem>
          </span>
        ) : null}
      </Menu>
    </div>
  );
}

export default TransactionsList;
